import { enableMapSet, enablePatches, produceWithPatches } from "../../../../immer/dist/immer.js";
import clone_default from "../../../../lodash-es/clone.js";
import isEqual_default from "../../../../lodash-es/isEqual.js";

//#region ../../node_modules/@jwplayer/fe-common/module/store/index.js
enablePatches();
enableMapSet();
function createSubscription(store, subscriber, stateSelector) {
	let lastState = store.getState(stateSelector);
	const queue = [];
	let subscriberIsBusy = false;
	const act = () => {
		const nextState = store.getState(stateSelector);
		if (isEqual_default(nextState, lastState)) return;
		subscriberIsBusy = true;
		subscriber(nextState, lastState);
		subscriberIsBusy = false;
		lastState = nextState;
	};
	return () => {
		if (subscriberIsBusy) {
			queue.push(() => act());
			return;
		}
		act();
		while (queue.length) {
			const nextAct = queue.shift();
			nextAct?.();
		}
	};
}
var Store = class {
	_subscribers = [];
	initialState;
	state;
	_fireSubscribers() {
		for (const subscriber of this._subscribers) subscriber();
	}
	constructor(initialState) {
		const copy = clone_default(initialState);
		this.initialState = [copy];
		this.state = copy;
	}
	/**
	* Subscribe to state updates
	*
	* @param stateSelector Function to select a subset of the state
	* @param subscriber Function that passes the next and previous states
	* @returns
	*/
	subscribe(stateSelector, subscriber) {
		const sub = createSubscription(this, subscriber, stateSelector);
		this._subscribers.push(sub);
		const unsub = () => {
			this._subscribers = this._subscribers.filter((s) => s !== sub);
		};
		return unsub;
	}
	getInitialState() {
		return clone_default(this.initialState);
	}
	setInitialState(state, reset = true) {
		this.initialState.push(state);
		if (reset) this.resetToInitialState();
	}
	resetToInitialState() {
		const lastInitialState = this.getInitialState().at(-1);
		if (!lastInitialState) throw new Error("Could not find initial state!");
		this.state = lastInitialState;
		this._fireSubscribers();
	}
	setState(arg) {
		if (arg instanceof Function) {
			const [result, patches] = produceWithPatches(this.state, arg);
			if (!patches.length) return result;
			this.state = result;
		} else this.state = clone_default(arg);
		this._fireSubscribers();
		return this.state;
	}
	/**
	* @deprecated - Old method name. Use `setState` instead.
	*/
	update = this.setState;
	getState(stateSelector) {
		const currentState = clone_default(this.state);
		return stateSelector ? stateSelector(currentState) : currentState;
	}
	/**
	* @deprecated - Old method name. Use `getState` instead.
	*/
	getCurrentState = this.getState;
	when(stateSelector, assertFn) {
		return new Promise((resolve) => {
			const currentState = this.getState(stateSelector);
			if (assertFn(currentState)) return resolve(currentState);
			const unsub = this.subscribe(stateSelector, (nextState) => {
				if (assertFn(nextState)) {
					unsub();
					return resolve(nextState);
				}
			});
		});
	}
};

//#endregion
export { Store };
//# sourceMappingURL=index.js.map